import React from 'react';
import './Hero.css';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import { ChevronRight } from 'lucide-react';
import hero4 from '../assets/Hero_section/erp.webp';
import hero5 from '../assets/Hero_section/cloud2.webp';
import hero6 from '../assets/Hero_section/AI.webp';
import hero7 from '../assets/Hero_section/business-process-automation.webp';

import logo1 from '../assets/Clients Logo/3i group.webp';
import logo1m from '../assets/Clients Logo/3i group-320w.webp';
import logo2 from '../assets/Clients Logo/Elsevier_Limited_Logo.webp';
import logo2m from '../assets/Clients Logo/Elsevier_Limited_Logo-320w.webp';
import logo3 from '../assets/Clients Logo/Indian express.webp';
import logo3m from '../assets/Clients Logo/Indian express-320w.webp';
import logo4 from '../assets/Clients Logo/Ladera-Technology.webp';
import logo4m from '../assets/Clients Logo/Ladera-Technology-320w.webp';
import logo5 from '../assets/Clients Logo/Linde_plc_logo.webp';
import logo5m from '../assets/Clients Logo/Linde_plc_logo-320w.webp';
import logo6 from '../assets/Clients Logo/MgM Healthcare.webp';
import logo7 from '../assets/Clients Logo/Redignton.webp';
import logo8 from '../assets/Clients Logo/TAFE_Logo.webp';
import logo9 from '../assets/Clients Logo/Tata-Logo.webp';
import logo10 from '../assets/Clients Logo/esskay-logo.webp';
import logo11 from '../assets/Clients Logo/hutsun foodss.webp';
import logo12 from '../assets/Clients Logo/ramco.webp';

export const Hero: React.FC = () => {
  const [currentSlide, setCurrentSlide] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev === 3 ? 0 : prev + 1));
    }, 3000); // Display time set to 3 seconds for a fast change
    return () => clearInterval(timer);
  }, []);

  // Client logos — icon color + name only (no card, no border)
  const clientLogos = [
    { id: 1, name: '3i Group', logo: logo1, mobileLogo: logo1m },
    { id: 2, name: 'Elsevier', logo: logo2, mobileLogo: logo2m },
    { id: 3, name: 'Indian Express', logo: logo3, mobileLogo: logo3m },
    { id: 4, name: 'Ladera Technology', logo: logo4, mobileLogo: logo4m },
    { id: 5, name: 'Linde plc', logo: logo5, mobileLogo: logo5m },
    { id: 6, name: 'MgM Healthcare', logo: logo6 },
    { id: 7, name: 'Redington', logo: logo7 },
    { id: 8, name: 'TAFE', logo: logo8 },
    { id: 9, name: 'Tata', logo: logo9 },
    { id: 10, name: 'Esskay', logo: logo10 },
    { id: 11, name: 'Hatsun Foods', logo: logo11 },
    { id: 12, name: 'Ramco', logo: logo12 },
  ];

  return (
    <section className="hero-section" id="home">

      <div className="hero-bg-slider">
        <img draggable={false} style={{ pointerEvents: 'none', userSelect: 'none' }} className={`hero-bg-slide ${currentSlide === 0 ? 'active' : ''}`} src={hero4} alt="Hero Background 1" width="625" height="350" fetchPriority="high" />
        <img draggable={false} style={{ pointerEvents: 'none', userSelect: 'none' }} className={`hero-bg-slide ${currentSlide === 1 ? 'active' : ''}`} src={hero5} alt="Hero Background 4" width="625" height="350" />
        <img draggable={false} style={{ pointerEvents: 'none', userSelect: 'none' }} className={`hero-bg-slide ${currentSlide === 2 ? 'active' : ''}`} src={hero6} alt="Hero Background 5" width="625" height="350" />
        <img draggable={false} style={{ pointerEvents: 'none', userSelect: 'none' }} className={`hero-bg-slide ${currentSlide === 3 ? 'active' : ''}`} src={hero7} alt="Hero Background 6" width="625" height="350" />
      </div>


      {/* Directional overlay: stronger on the left for text readability, clear on the right for the globe */}
      <div className="hero-overlay" />

      <div className="container hero-container">
        {/* ── LEFT: Text & CTA ── */}
        <div className="hero-left">
          <div className="hero-sys-label">
            <div className="status-dot live-pulse"></div>
            <span>VIVIFY SOFTWARE SOLUTIONS</span>
          </div>

          {currentSlide === 0 ? (
            <h1 key={0} className="hero-headline">
              <span className="weight-light">Powering</span><br />
              <span className="weight-light">Smarter Enterprises</span><br />
              <span className="text-amber headline-blue-accent">with Intelligent</span><br />
              <span className="weight-bold">Software</span>
            </h1>
          ) : currentSlide === 1 ? (
            <h1 key={1} className="hero-headline">
              <span className="weight-light">Power Your</span><br />
              <span className="weight-light">Business with</span><br />
              <span className="text-amber headline-blue-accent">Smarter Cloud</span><br />
              <span className="weight-bold">&amp; IT</span>
            </h1>
          ) : currentSlide === 2 ? (
            <h1 key={2} className="hero-headline">
              <span className="weight-light">AI That</span><br />
              <span className="weight-light">Turns Business Data</span><br />
              <span className="text-amber headline-blue-accent">into Better</span><br />
              <span className="weight-bold">Decisions</span>
            </h1>
          ) : currentSlide === 3 ? (
            <h1 key={3} className="hero-headline">
              <span className="weight-light">Work Smarter</span><br />
              <span className="weight-light">with Intelligent</span><br />
              <span className="text-amber headline-blue-accent">Business</span><br />
              <span className="weight-bold">Automation</span>
            </h1>
          ) : (
            <h1 key={4} className="hero-headline">
              <span className="weight-light">Intelligent</span><br />
              <span className="weight-light">Automation</span><br />
              <span className="text-amber headline-blue-accent">for Modern</span><br />
              <span className="weight-bold">Businesses</span>
            </h1>
          )}

          <p className="hero-sub">
            We design automation that brings clarity, precision, and efficiency to the way your company operates.
          </p>

          <div className="hero-actions">
            <Link to="/contact">
              <Button
                variant="primary"
                size="sm"
                icon={<ChevronRight size={14} />}
                className="about-hero-primary-btn hero-compact-btn"
                glow
              >
                Book Consultation
              </Button>
            </Link>
            <Link to="/services">
              <Button
                variant="primary"
                size="sm"
                icon={<ChevronRight size={14} />}
                className="about-hero-primary-btn hero-compact-btn"
                glow
              >
                Explore Services
              </Button>
            </Link>
            <Link to="/solutions">
              <Button
                variant="primary"
                size="sm"
                icon={<ChevronRight size={14} />}
                className="about-hero-primary-btn hero-compact-btn"
                glow
              >
                View Solutions
              </Button>
            </Link>
          </div>
        </div>


      </div>

      {/* Client Logos marquee strip */}
      <div className="hero-clients-section">
        <div className="hero-marquee-wrapper">
          <div className="hero-marquee-track">
            {[...clientLogos, ...clientLogos, ...clientLogos].map((client, idx) => (
              <div key={`${client.id}-${idx}`} className="hero-marquee-item">
                <img src={client.logo}
                  srcSet={client.mobileLogo ? `${client.mobileLogo} 320w, ${client.logo} 1000w` : undefined}
                  sizes={client.mobileLogo ? "(max-width: 768px) 160px, 160px" : undefined}
                  alt={client.name}
                  width="160"
                  height="40"
                  style={{ height: '40px', width: 'auto', objectFit: 'contain', maxWidth: '160px', borderRadius: '4px', background: '#fff', padding: '4px' }}
                  title="Vivify Soft Tech" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
